import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchAsyncGetAutomatedBank } from "redux/embrillProfileSlice";
const useBankDetails = () => {
  const [orgBank, setOrgBank] = useState({});
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchPaidByDetails = async () => {
      const res = await dispatch(fetchAsyncGetAutomatedBank());
      if (res?.payload && res?.payload?._id) {
        const data = res?.payload;
        setOrgBank(data?.bnk || {});
      }
    };
    fetchPaidByDetails();
  }, [dispatch]);
  return orgBank;
};
export default useBankDetails;